<zaeper-tab-navigation [tabs]="tabs">
  <ng-template zTemplate="tab">
    <app-login-attempts-tab/>
  </ng-template>
</zaeper-tab-navigation>
